@if (elements.length > 0) { @if (headerKey) {
<p>{{ headerKey | translate }}:</p>
}
<ul>
  @for (element of elements; track element) {
  <li>
    @if (element?.labelKey) {
    {{ element.labelKey | translate }}
    } @if (element?.labelKey && element?.value) { &mdash; } @if (element?.value) {
    {{ element.value }}
    }
  </li>
  }
</ul>
}
